<ng-container *ngIf="showHeader">
  <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>
</ng-container>

<mat-card class="simple-card mx-auto">
  <mat-card-content>
    <div class="row">

      <div class="col-12 d-flex justify-content-between" *ngIf="!fromConsolidado && showHeader">
        <h1>Reporte Bienes Raíces</h1>
        <button mat-flat-button 
          class="custom-button-primary no-print"
          [printTitle]='"BienesRaices_"+(rut | rutFormat)+"_"+today'
          [useExistingCss]="true"
          printSectionId="print-section"
          ngxPrint
        >
          <mat-icon 
            aria-hidden="false" 
            aria-label="Icono de descarga" 
            fontIcon="get_app" 
            class="icon-download mr-3"
          ></mat-icon>
          Descargar Resultado
        </button>
      </div>

      <div class="col-12" *ngIf="fromConsolidado && showHeader">
        <h1>Reporte Bienes Raíces</h1>
      </div>

      <div class="col-12 my-3" *ngIf="showHeader">
        <mat-chip-set aria-label="Rut principal">
          <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.bienesraicesReporte.datosBasicosSolicitud.Rut | number: '1.0-0'}}-{{content.bienesraicesReporte.datosBasicosSolicitud.DV | uppercase}}</mat-chip>
        </mat-chip-set>
      </div>

      <div class="col-12">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="font-size-title-card">
              <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
              <strong>Información Básica</strong>
              <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.bienesraicesReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
            </mat-card-title>
          </mat-card-header>
        
          <mat-card-content>

            <div class="row p-5">
              <div class="col-12 border mx-auto">
                <table mat-table [dataSource]="datosBasicos" class="info-basica-table">
                  <ng-container matColumnDef="name">
                    <th mat-cell *matCellDef="let element" class="cell-font-size">{{element.name}}</th>
                  </ng-container>
                
                  <ng-container matColumnDef="value">
                    <td mat-cell *matCellDef="let element" class="cell-font-size">
                      <ng-container [ngSwitch]="element.name">
                        <ng-container *ngSwitchCase="'Número Total Bienes Raíces'">
                          {{element.value || element.value == 0 ? (element.value | number: '1.0-0') : element.value}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'Valor Total Bienes Raíces'">
                          M$ {{element.value || element.value == 0 ? (element.value | number: '1.0-0') : element.value}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'Rut'">
                          {{element.value ? (element.value | rutFormat) : ''}}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          {{element.value}}
                        </ng-container>
                      </ng-container>
                    </td>
                  </ng-container>
                
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns;"
                  ></tr>
                </table>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-12 mt-5 mb-3">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="font-size-title-card">
              <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
              <strong>Detalles</strong>
              <p class="d-inline fecha_size ml-2" *ngIf="fromConsolidado">({{content.bienesraicesReporte?.datosBasicosSolicitud?.FechaReporte | date: 'dd-MM-yyyy'}})</p>
            </mat-card-title>
          </mat-card-header>
        
          <mat-card-content class="full-size-print">

            <div class="row p-5 full-size-print" *ngIf="content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices.length > 0; else noData">
              <div class="col-12 border mx-auto px-0">

                <div class="table-responsive">
                  <table mat-table [dataSource]="tableBienesRaices" class="tabla-detalles">
                    <ng-container matColumnDef="rol_predio">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['rol_predio']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.rol_predio}} </td>
                    </ng-container>
                    <ng-container matColumnDef="rol_manzana">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['rol_manzana']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.rol_manzana}} </td>
                    </ng-container>
                    <ng-container matColumnDef="cod_comuna">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['cod_comuna']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.cod_comuna}} </td>
                    </ng-container>
                    <ng-container matColumnDef="direccion">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['direccion']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.direccion}} </td>
                    </ng-container>
                    <ng-container matColumnDef="comuna">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['comuna']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.comuna}} </td>
                    </ng-container>
                    <ng-container matColumnDef="ciudad">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['ciudad']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.ciudad}} </td>
                    </ng-container>
                    <ng-container matColumnDef="region">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['region']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.region}} </td>
                    </ng-container>
                    <ng-container matColumnDef="serie">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['serie']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.serie}} </td>
                    </ng-container>
                    <ng-container matColumnDef="ubicacion">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['ubicacion']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.ubicacion}} </td>
                    </ng-container>
                    <ng-container matColumnDef="destino">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['destino']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.destino}} </td>
                    </ng-container>
                    <ng-container matColumnDef="avaluo_exento">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['avaluo_exento']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.avaluo_exento | number: '1.0-0'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="anio_exencion">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['anio_exencion']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.anio_exencion}} </td>
                    </ng-container>
                    <ng-container matColumnDef="total_a_pagar">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['total_a_pagar']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.total_a_pagar | number: '1.0-0'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="avaluo_total">
                      <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['avaluo_total']}} </th>
                      <td mat-cell *matCellDef="let element"> {{element.avaluo_total | number: '1.0-0'}} </td>
                    </ng-container>
                  
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBienesRaices"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBienesRaices;"></tr>
                  </table>
                </div>
                
              </div>
            </div>

            <ng-template #noData>
              <div class="row p-5">
                <div class="col-12 border mx-auto px-0">

                  <div class="table-responsive">
                    <table mat-table class="">
                      <ng-container matColumnDef="rol_predio">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['rol_predio']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="rol_manzana">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['rol_manzana']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="cod_comuna">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['cod_comuna']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="direccion">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['direccion']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="comuna">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['comuna']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="ciudad">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['ciudad']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="region">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['region']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="serie">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['serie']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="ubicacion">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['ubicacion']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="destino">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['destino']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="avaluo_exento">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['avaluo_exento']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="anio_exencion">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['anio_exencion']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="total_a_pagar">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['total_a_pagar']}} </th>
                      </ng-container>
                      <ng-container matColumnDef="avaluo_total">
                        <th mat-header-cell *matHeaderCellDef> {{BienesRaicesText['avaluo_total']}} </th>
                      </ng-container>
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsBienesRaices"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsBienesRaices;"></tr>
                    </table>
                  </div>

                </div>
              </div>
            </ng-template>

          </mat-card-content>
        </mat-card>
      </div>

    </div>
  </mat-card-content>
</mat-card>
